import axios from 'axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {},
    statistiche: {},
    utenze: {},
    parametri: {},
    tipiRapportoUtenza: [
      { value: 'E', text: 'ERP' },
      { value: 'V', text: 'VENDITA' },
      { value: 'C', text: 'CONCESSIONE' },
      { value: 'N', text: 'NON ERP' },
      { value: 'F', text: 'CAMPIDOGLIO FINANCE' }
    ],
    utentiPossibili: [],
    destinatariRealtime: 0,
    sezioni: [
      { value: 'COMUNICAZIONI', text: 'COMUNICAZIONI' },
      { value: 'NEWS', text: 'NEWS' }
    ]
  },

  getters: {
    items (state) {
      return state.items || []
    },
    item (state) {
      return state.item || {}
    },
    statistiche (state) {
      return state.statistiche.riepilogo || {}
    },
    utenze (state) {
      return state.utenze || {}
    },
    destinatariItems (state) {
      return state.statistiche.destinatari || []
    },
    destinatariItemsAll (state) {
      return state.statistiche.destinatariAll || []
    },
    tipiRapportoUtenza (state) {
      // return state.tipiRapportoUtenza
      return state.parametri.tipoDestinatari || {}
    },
    sezioni (state) {
      return state.sezioni
    },
    utentiPossibili (state) {
      return state.utentiPossibili || []
    },
    destinatariRealtime (state) {
      // return state.statistiche.riepilogo.destinatari || -99
      return state.destinatariRealtime || { destinatari: -99, tipoDest: '-' }
    }
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    },
    setStatistiche (state, value) {
      state.statistiche = value || {}
    },
    setParametri (state, value) {
      state.parametri = value || {}
    },
    setUtenze (state, value) {
      state.utenze = value || {}
    },
    setUtentiPossibili (state, value) {
      state.utentiPossibili = value || {}
    },
    setDestinatariRealtime (state, value) {
      state.destinatariRealtime = value || {}
    }
  },

  actions: {
    resetItem ({ commit }) {
      const item = {
        id: '',
        creatoDa: '',
        testoBreve: '',
        testo: '',
        allegato: undefined,
        dataInizio: '',
        dataFine: '',
        tipoDest: 'U',
        utente: '',
        gruppo: '',
        sezioneRiferimento: '',
        attivo: 0,
        creato: '',
        ultimaModifica: '',
        tipoComunicazione: 'NOTIFICA',
        dataDa: '',
        tempoDa: '',
        dataA: '',
        tempoA: '',
        file: undefined // computed

      }
      commit('setItem', item)
    },

    async loadItems ({ commit }, params) {
      try {
        let rs = await axios.get('/api/notifiche', { params })
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },

    async loadItemById ({ commit }, params) {
      try {
        const rs = await axios.get(`/api/notifiche/${params.id}`, { params })
        const item = Object.assign(rs.data, {
          dataDa: extractDate(rs.data.dataInizio),
          tempoDa: extractTime(rs.data.dataInizio),
          dataA: extractDate(rs.data.dataFine),
          tempoA: extractTime(rs.data.dataFine),
          file: undefined
        })
        // console.log('item', item)
        commit('setItem', item)
      } catch (err) {
        throw err
      }
    },

    async checkUtenze ({ commit }, params) {
      // { utenze: newRows }
      try {
        const rs = await axios.get(`/api/notifiche/checkUtenze`, { params })
        // console.log('item cleaned', rs.data)
        commit('setUtenze', rs.data)
        return rs.data
      } catch (err) {
        throw err
      }
    },

    async loadStatisticheById ({ commit }, params) {
      try {
        const rs = await axios.get(`/api/notifiche/${params.id}/statistiche`, { params })

        // const item = Object.assign(rs.data)

        // console.log('setStatistiche', rs.data)

        commit('setStatistiche', rs.data)
      } catch (err) {
        throw err
      }
    },

    async ricercaUtenti ({ commit }, params) {
      try {
        const rs = await axios.get(`/api/notifiche/utenti`, { params })

        // const item = Object.assign(rs.data)

        // console.log('utenti validi', rs.data.utenti)

        commit('setUtentiPossibili', rs.data.utenti)
      } catch (err) {
        throw err
      }
    },

    async loadDestinatariRealtime ({ commit }, params) {
      try {
        // console.log('Destinatari possibili PRIMA', params)

        const rs = await axios.get(`/api/notifiche/checkDestinatari`, { params })
        // const item = Object.assign(rs.data)
        // console.log('Destinatari possibili', rs.data)

        commit('setDestinatariRealtime', rs.data)
      } catch (err) {
        throw err
      }
    },

    async loadParametriNotifiche ({ commit }) {
      try {
        const rs = await axios.get(`/api/notifiche/parametri`)

        // const item = Object.assign(rs.data)
        // console.log('setParametri', rs.data)

        commit('setParametri', rs.data)
      } catch (err) {
        throw err
      }
    },

    async addNew ({ commit }, { item, formData }) {
      try {
        // const data = {
        //   tipoDest: item.tipoDest || 'U',
        //   gruppo: item.gruppo || null,
        //   utente: item.utente || null,
        //   sezioneRiferimento: item.sezioneRiferimento,
        //   testoBreve: item.testoBreve,
        //   testo: item.testo,
        //   dataInizio: item.dataDa,
        //   dataFine: item.dataA
        // }

        // console.log('notifiche addNew', formData)
        // const rs = await axios.post(`/api/notifiche`, data)
        let rs = await axios({ method: 'post', url: `/api/notifiche`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        commit('setItem', rs.data)
        return rs.data
      } catch (err) {
        throw err
      }
    },

    async save ({ commit }, { id, userAdmin, formData }, params) {
      try {
        // const data = {
        //   id: item.id,
        //   tipoDest: item.tipoDest || 'U',
        //   gruppo: item.gruppo || null,
        //   utente: item.utente || null,
        //   sezioneRiferimento: item.sezioneRiferimento,
        //   testoBreve: item.testoBreve,
        //   testo: item.testo,
        //   dataInizio: item.dataDa,
        //   dataFine: item.dataA
        // }

        // let rs = await axios.put(`/api/notifiche/${item.id}`, data, { params })
        let appFormNotifica = formData.getAll('notifica')

        // console.log('notifiche save', appFormNotifica, formData.getAll('allegato'))

        let rs = await axios({ method: 'put', url: `/api/notifiche/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' }, params })

        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async publish ({ commit }, item) {
      try {
        const data = {
          id: item.id,
          tipoDest: item.tipoDest || 'U',
          gruppo: item.gruppo || null,
          utente: item.utente || null,
          sezioneRiferimento: item.sezioneRiferimento,
          testoBreve: item.testoBreve,
          testo: item.testo,
          dataInizio: item.dataDa,
          dataFine: item.dataA
        }

        let rs = await axios.put(`/api/notifiche/${item.id}/pubblica`, data)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async deleteById ({ commit }, id) {
      try {
        axios.delete(`/api/notifiche/${id}`)
        commit('setItem', null)
      } catch (err) {
        throw err
      }
    }

  }
}

function extractDate (datetime) {
  // console.log('extractDate datetime', datetime, moment(datetime).format('YYYY-MM-DD'))
  // return datetime ? datetime.substring(0, 10) : ''
  return datetime ? moment(datetime).format('YYYY-MM-DD') : ''
}
function extractTime (datetime) {
  return datetime ? datetime.substring(11, 16) : ''
}

// function buildDate (date, time, beginTime = true) {
//   if (!date) return ''
//   let rs = `${date} ${time || (beginTime ? '00:00:00' : '23:59:59')}`
//   // rs = moment(rs).format()
//   console.log('buildDate', date, time, beginTime, rs)
//   return rs
// }
